import React, { createContext, useContext, useState } from 'react';
import './toaster.scss';

const ToasterContext = createContext();

export function ToasterProvider({ children }) {
  const provider = useToasterProvider();
  return (
    <ToasterContext.Provider value={provider}>
      {children}
    </ToasterContext.Provider>
  );
}

function useToasterProvider() {
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState({ type: 'success', text: '' });

  function toast(toastInfo) {
    setOpen(true);
    setInfo(toastInfo);
  }

  return {
    toast,
    open,
    info,
    setOpen,
  };
}

export default () => useContext(ToasterContext);
